import { cn } from "logic/utils";
import { ReactNode } from "react";

import { Skeleton } from "./Skeleton";

/**
 * A metric value in one of three display states, rendered by {@link Ty}:
 * - a node — render it as-is
 * - `null` — resolved, but there is no value to show → `--`
 * - `undefined` — not resolved yet → skeleton
 *
 * Producers must keep `null` and `undefined` distinct: `??` and `?.` collapse
 * the two, so propagate with `value && <Node />` instead, which preserves both.
 */
export type MetricTy = ReactNode | null | undefined;

interface TyProps {
  className?: string;
  stateLess?: boolean;
  value: MetricTy;
}

export function Ty(props: TyProps) {
  const { className, stateLess = false, value } = props;

  if (!stateLess) {
    // Carries `className` like the value branches below, so a placeholder keeps
    // the size and colour of the metric it stands in for.
    if (value === null) return <span className={className}>--</span>;
    if (value === undefined) return <Skeleton className={cn("w-full h-4", className)} />;
  }

  if (typeof value === "string") {
    return <span className={className}>{value}</span>;
  }

  return <div className={className}>{value}</div>;
}
